import { render, staticRenderFns } from "./ComponentError.vue?vue&type=template&id=40ed73f8&"
import script from "./ComponentError.vue?vue&type=script&lang=js&"
export * from "./ComponentError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports